import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useIconProps } from '../useIconProps';

var FeedbackSuccess = function FeedbackSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M5.972 11.921l-.004-.003-2.822-2.822a.5.5 0 010-.707l.708-.707a.5.5 0 01.707 0L6.328 9.45l5.304-5.304a.5.5 0 01.707 0l.707.708a.5.5 0 010 .707l-6.364 6.364a.5.5 0 01-.707 0l-.003-.004z"
  }));
};

FeedbackSuccess.displayName = 'FeedbackSuccess';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  FeedbackSuccess.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default FeedbackSuccess;